import Splide from "@splidejs/splide";

export const stepSlider = () => {
  const stepSlider = new Splide(".js-step-slider", {
    gap: "2rem",
    arrows: false,
    padding: {
      left: "2rem",
      right: "2rem",
    },
  }).mount();
};
